import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { Stream, StreamContent } from "@/partner/entities/streams";
import { PollsPanel } from "@/partner/features/polls";
import { ContentTypeType } from "@/types/graphql/partner.generated";
import { StreamDialogHeader } from "./StreamDialogHeader";

interface StreamPollsTabProps {
  content: StreamContent;
  stream: Stream;
  onClose: () => void;
}

// Вкладка «Опросы» формы эфира: свой fixed-хедер, как у остальных вкладок.
export const StreamPollsTab: FC<StreamPollsTabProps> = ({
  content,
  stream,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <StreamDialogHeader
        title={t("streams.form.dialogTitle")}
        onClose={onClose}
      />
      <PollsPanel
        contentId={content.id}
        contentType={ContentTypeType.StreamType}
        streamStatus={stream.status}
      />
    </>
  );
};
